<template>
    <div>
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Ambis Test',
                    to: { path: '/ambis-test' },
                },
                { text: 'List Bundle Subtes' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div class="d-flex">
            <h3 class="header-text font-weight-bold">Bundle Subtes</h3>
        </div>

        <v-card flat>
            <v-card-title>
                <div class="font-size-16 font-weight-600">
                    Daftar Bundle Subtes
                </div>
                <v-spacer />

                <v-btn
                    depressed
                    color="blew"
                    dark
                    @click="$router.push('/ambis-test/create-bundle')"
                >
                    <v-icon>mdi-plus</v-icon> Tambah Bundle
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    placeholder="Masukan kata kunci pencarian"
                    dense
                    outlined
                    class="mb-4"
                    hide-details
                ></v-text-field>

                <v-data-table
                    v-model="datatable"
                    item-key="bundle_code"
                    :headers="headers"
                    :items="bundles"
                    :search="search"
                    :loading="loading"
                    no-data-text="Data bundle subtes tidak tersedia"
                >
                    <template v-slot:item.actions="{ item }">
                        <v-btn
                            small
                            depressed
                            color="lightred"
                            class="red--text"
                            @click="confirmDeleteItem(item)"
                        >
                            Hapus
                        </v-btn>

                        <v-btn
                            small
                            depressed
                            color="lightblue"
                            class="blew--text"
                            @click="editBundle(item)"
                        >
                            Edit
                        </v-btn>
                    </template>

                    <template v-slot:no-results>
                        <div class="text-center">
                            <p class="my-2">Hasil pencarian tidak ditemukan.</p>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <v-dialog v-model="confirmDialog" persistent max-width="450">
            <dialog-confirm
                :title="'Hapus Bundle Subtes'"
                :subtitle="'Apakah anda akan menghapus Bundle Subtes ini ?'"
                @close="confirmDialog = false"
                @confirm="deleteBundle()"
            />
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import DialogConfirm from "@/modules/global/components/DialogConfirm";
import ambis_test from "../services/ambis_test";

export default {
    components: {
        "dialog-confirm": DialogConfirm,
    },

    data() {
        return {
            loading: false,
            confirmDialog: false,
            datatable: null,
            search: null,
            headers: [
                { text: "Kode", value: "bundle_code", width: 150 },
                { text: "Nama", value: "name" },
                { text: "Deskripsi", value: "description" },
                { text: "Total Soal", width: 150, value: "total_questions" },
                {
                    text: "Aksi",
                    width: 150,
                    value: "actions",
                    sortable: false,
                },
            ],
            bundles: [],
            selectedRow: null,
        };
    },

    mounted() {
        this.getBundles();
    },

    methods: {
        async getBundles() {
            const self = this;
            self.loading = true;

            const url = `${process.env.API_BASE_URL}ambis-test/test-tryouts`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            try {
                const response = await axios.get(url, options);
                self.bundles = response.data || [];
            } catch (error) {
                self.$store.commit("alert/showAlert", {
                    type: "error",
                    message: "Data bundles subtes tidak tersedia",
                });
            } finally {
                self.loading = false;
            }
        },

        editBundle(data) {
            var context = this;
            var id = data.test_id;

            context.$router.push({
                path: "/ambis-test/create-bundle",
                query: {
                    id: id,
                },
            });
        },

        confirmDeleteItem(val) {
            this.selectedRow = val;
            this.confirmDialog = true;
        },

        deleteBundle() {
            var context = this;
            const id = context.selectedRow.test_id;

            context.loading = true;

            ambis_test.deleteBundle(id, function (result) {
                if (result.success) {
                    context.confirmDialog = false;
                    context.getBundles();
                    context.loading = false;
                } else {
                    context.loading = false;
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// ListBundle.vue?2dba56ca